<template>
  <Error404 v-if="!tenantFound" />
  <div
    v-else-if="!storeIsActive || activeMode == 6"
    class="tenantnotfound flex row items-center justify-center"
  >
    <div class="col-12 col-md-6 text-center q-pa-md">
      <q-img
        src="images/inactive_picture.jpg"
        style="max-width: 500px; width: 100%; height: auto"
      />
    </div>
    <div class="col-12 col-md-6 q-pa-md">
      <!-- <div class="q-mt-md tenantnotfound-title" v-if="!tenantFound">
        OPPS,<br />
        Tenant not found
      </div> -->
      <div class="q-mt-md tenantnotfound-title">
        OPPS,<br />
        {{ title }}
      </div>
      <!-- <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi fugit
        <br />
        voluptatem tenetur a in unde eos dicta doloribus quidem, odio autem
      </p> -->
      <!-- <q-btn color="primary" label="Go Back" @click="goBack" /> -->
    </div>
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue'
import { useCommonStore } from 'src/stores/common'
import { usePersistedStore } from 'src/stores/persisted'
import { mapState } from 'pinia'

export default {
  name: 'StoreNotActive',
  components: {
    Error404: defineAsyncComponent(() => import('components/common/Error404')),
  },
  methods: {
    goBack() {
      if (typeof window !== 'undefined') window.history.back()
    },
  },
  computed: {
    ...mapState(useCommonStore, ['tenantFound', 'storeIsActive']),
    ...mapState(usePersistedStore, ['activeMode']),
    title() {
      let msg = ''
      if (this.activeMode == 6)
        msg = 'This e-commerce site is currently closed.'
      else if (!this.storeIsActive)
        msg = 'This site is currently under construction.'
      return msg
    },
  },
}
</script>
<style lang="scss">
.tenantnotfound {
  min-height: 100dvh;
  font-size: 16px;

  .tenantnotfound-title {
    font-size: 40px;
    font-weight: 600;
    line-height: 1.4;
    margin-bottom: 15px;
  }
  @media (max-width: 1024px) {
    text-align: center;
    .tenantnotfound-title {
      font-size: 24px;
    }
  }
}
</style>
